/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, Dimensions, FlatList, ScrollView } from 'react-native'
import styles from './Styles/ExploraDiscoverStyle'
import PostWallListComponent from './PostWallListComponent'
import IconPostWallComponent from './IconPostWallComponent'
import { Colors } from '../Themes'
let { width, height } = Dimensions.get('window')
let widthCellBase = width / 3
let widthCell = widthCellBase

const viewabilityConfig = { viewAreaCoveragePercentThreshold : -200, minimumViewTime : 50 }
export default class ExploraDiscover extends Component {
  constructor(props) {
    super(props)
    // web 
    let factor = window.mainViewWidthFraction ? window.mainViewWidthFraction : 1
    widthCell = widthCellBase * factor
  }

  onViewableItemsChanged = ({ changed, viewableItems }) => {
    var viewable = 0, hit = 0
    if(! viewableItems.length) return false
    
    for(var i = 0, data = this.props.data[i]; i < this.props.data.length; data = this.props.data[++i]) {
      // hack for web
      //data.viewable = true

      if(i == viewableItems[0].index) {
        data.viewable = true
        hit = 1
        ++viewable
      }
      else if(hit && viewableItems.length > hit) ++hit && ++viewable && (data.viewable = true)
      else if(data.viewable) ++viewable
    }
    if(hit > 0 || viewable === this.props.data.length) this.props.resetIdleTimeout(hit)
    let offscreenElements = 30
    var min = viewableItems[0].index, max = viewableItems[viewableItems.length -1].index
    if(min - offscreenElements < 0) min = 0; else min = min - offscreenElements
    if(max + offscreenElements > this.props.data.length -1) max = this.props.data.length -1; else max = max + offscreenElements
    for(var i = min; i < min+offscreenElements; ++i) if(this.props.data[i]) this.props.data[i].viewable = true
    for(var i = max; i > max-offscreenElements; --i) if(this.props.data[i]) this.props.data[i].viewable = true
    if(hit > 0 || viewable === this.props.data.length) this.props.resetIdleTimeout(hit)

    // when 100% of items are viewable, signal idle state immediately
    // set a timeout of DownloadImageAverageTime, then signal idle state
    // when idle state is procced, we'll 'finally' download other tabs in the background
    this.setState({ render : true })
    // for(var i = 0; i < changed.length; ++ i) if(! changed[i].isViewable && this.props.data[changed[i].index]) this.props.data[changed[i].index].viewable = false
  }

  render( ) {
    let containerStyle = { paddingBottom : 333, backgroundColor : 'white', flexDirection : 'row', flexWrap : 'wrap', alignItems : 'center', justifyContent : 'flex-start' }
    return (
        <FlatList contentContainerStyle={containerStyle} data={this.props.data} numColumns={3}
            onViewableItemsChanged={this.onViewableItemsChanged}
            viewabilityConfig={viewabilityConfig} ListEmptyComponent={this.props.empty}
            keyExtractor={(item, index) => `${index}-${item.PostId}`}
            onRefresh={this.props.onRefresh} refreshing={this.props.refreshing}
            renderItem={({ item, index }) =>
                true /*item.viewable hack for web*/
                    ? <View style={{ width : widthCell, height : widthCell, overflow : 'hidden' }}>
                          <PostWallListComponent key={item.PostId} viewMode={this.props.viewMode} data={item}
                              imageHeight={widthCell} imageWidth={widthCell}
                              onPress={( ) => this.props.onPressItem && this.props.onPressItem(item, index)}/>
                      </View>
                    : <View style={{ width : widthCell, height : widthCell, backgroundColor : item.tileColor, borderWidth : 1, borderColor : 'white' }}/>
            }/>

    )
  }
}
